import styled from 'styled-components'

export const LoadingWrapper = styled.div`
    background: #181818;
    display: flex;
    align-items: center;
    justify-content: center;
    @keyframes spin {
        0% { transform: rotate(0deg); }
        25% { transform: rotate(-90deg); }
        50% { transform: rotate(-180deg); }
        75% { transform: rotate(-270deg); }
        100% { transform: rotate(-360deg); }
  }
`;
export const LoadingSpin = styled.div`
    animation: spin 1s linear infinite;
    margin: auto;
    opacity: 0.8;
`;